import {
  ConsultantFormErrors,
  ConsultantFormState,
  ConsultantUser,
} from "src/types/marriageConsultants.types";

// ── Constants ─────────────────────────────────────────────────────────

export const CONSULTANT_EMPTY_FORM: ConsultantFormState = {
  email: "",
  fullName: "",
  mobileNo: "",
  dailyRequestCountLimit: 5,
  marriage_profile_limit: 1,
};

export const CONSULTANT_TABLE_HEADERS = [
  "ID",
  "Full Name",
  "Email",
  "Mobile No.",
  "Daily Request Limit",
  "Profile Limit",
  "Status",
  "Active",
  "Actions",
] as const;

// ── Mapper ────────────────────────────────────────────────────────────

/** Maps a raw API response object to a typed ConsultantUser. */
export const mapConsultantResponse = (c: any): ConsultantUser => ({
  id: c.id ?? 0,
  email: c.email ?? "",
  fullName: c.fullName ?? "",
  mobileNo: c.mobileNo ?? "",
  approved: Boolean(c.approved),
  dailyRequestCountLimit: c.dailyRequestCountLimit ?? 5,
  marriage_profile_limit: c.marriage_profile_limit ?? 1,
});

// ── Validation ────────────────────────────────────────────────────────

export const validateConsultantForm = (
  f: ConsultantFormState): ConsultantFormErrors => {
  const e: ConsultantFormErrors = {};

  if (!f.email.trim()) {
    e.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) {
    e.email = "Enter a valid email address";
  }

  if (!f.mobileNo.trim()) {
    e.mobileNo = "Mobile number is required";
  } else if (!/^\d{10}$/.test(f.mobileNo.replace(/\D/g, ""))) {
    e.mobileNo = "Enter a valid 10-digit mobile number";
  }

  const limit = Number(f.dailyRequestCountLimit);
  if (!Number.isFinite(limit) || limit < 1) {
    e.dailyRequestCountLimit = "Must be a number ≥ 1";
  }

  const mpLimit = Number(f.marriage_profile_limit);
  if (!Number.isFinite(mpLimit) || mpLimit < 1) {
    e.marriage_profile_limit = "Must be a number ≥ 1";
  }

  return e;
};
